import {
  CampaignQCCallAnalyze,
  CampaignQCCallConversation,
  CampaignQCCallHistory,
  CampaignQCCallInfo,
  ViewCampaignQCCallAnalyze,
  ViewCampaignQCCallConversation,
  ViewCampaignQCCallHistory,
  ViewCampaignQCCallInfo,
} from 'app/common/services/SmartQC.service';
import * as moment from 'moment';
import { formatDurationIntoXmXXSeconds, convertDurationInSecondIntoDisplayTimeFormat } from '../util';

export enum TabKey {
  Emotion = 'emotion',
  Intent = 'intent',
  Keyword = 'keyword',
  Other = 'other',
  Comment = 'comment',
}

export type Tab = {
  key: TabKey;
  title: string;
  disabled: boolean;
};

export function buildTabs(): Tab[] {
  return [
    {
      key: TabKey.Emotion,
      title: 'Cảm xúc',
      disabled: false,
    },
    // {
    //   key: TabKey.Intent,
    //   title: 'Ý định',
    //   disabled: false,
    // },
    {
      key: TabKey.Keyword,
      title: 'Từ khóa',
      disabled: false,
    },
    {
      key: TabKey.Other,
      title: 'Khác',
      disabled: false,
    },
    // {
    //   key: TabKey.Comment,
    //   title: 'Trao đổi',
    //   disabled: false,
    // },
  ];
}

export function getDisplayCallAnalyzeEmotion(emotion: number): string {
  return `${emotion}`;
}

export function getDisplayCallAnalyzeEmotionAgent(emotionAgent: number): string {
  return `${emotionAgent}`;
}

export function getDisplayCallAnalyzeEmotionCustomer(emotionCustomer: number): string {
  return `${emotionCustomer}`;
}

export function getDisplayCallAnalyzeEndCallStatus(endCallStatus: number): string {
  return `${endCallStatus}`;
}

export function buildViewCallAnalyze(callAnalyze: CampaignQCCallAnalyze): ViewCampaignQCCallAnalyze {
  const wordSequence = callAnalyze.wordSequence || [];
  const wordAgentSequence = wordSequence
    .filter(ws => ws.user === 'Agent')
    .map(ws => ({
      keyword: ws.keyword,
      time: formatDurationIntoXmXXSeconds(ws.time),
    }));

  const wordCustomerSequence = wordSequence
    .filter(ws => ws.user === 'Customer')
    .map(ws => ({
      keyword: ws.keyword,
      time: formatDurationIntoXmXXSeconds(ws.time),
    }));

  const wordAgentGoods = callAnalyze.wordAgentGoods.map(ws => ({
    keyword: ws.keyword,
    time: formatDurationIntoXmXXSeconds(ws.time),
  }));

  const wordAgentUnPros = callAnalyze.wordAgentUnPros.map(ws => ({
    keyword: ws.keyword,
    time: formatDurationIntoXmXXSeconds(ws.time),
  }));

  const wordAgentForbids = callAnalyze.wordAgentForbids.map(ws => ({
    keyword: ws.keyword,
    time: formatDurationIntoXmXXSeconds(ws.time),
  }));

  const wordCustomerGoods = callAnalyze.wordCustomerGoods.map(ws => ({
    keyword: ws.keyword,
    time: formatDurationIntoXmXXSeconds(ws.time),
  }));
  const wordCustomerBads = callAnalyze.wordCustomerBads.map(ws => ({
    keyword: ws.keyword,
    time: formatDurationIntoXmXXSeconds(ws.time),
  }));

  const wordSpecial = callAnalyze.wordSpecial.map(ws => ({
    keyword: ws.keyword,
  }));

  return {
    ...callAnalyze,
    display_createdAt: moment(callAnalyze.createdAt).format('DD/MM/YYYY HH:mm:ss'),
    display_emotion: getDisplayCallAnalyzeEmotion(callAnalyze.emotion),
    display_emotionAgent: getDisplayCallAnalyzeEmotionAgent(callAnalyze.emotionAgent),
    display_emotionCustomer: getDisplayCallAnalyzeEmotionCustomer(callAnalyze.emotionCustomer),
    display_endCallStatus: getDisplayCallAnalyzeEndCallStatus(callAnalyze.endcallStatus),
    display_intents: !callAnalyze.intents.length ? '' : callAnalyze.intents.map(intent => intent.text).join(', '),
    display_intentMisses: !callAnalyze.intentMisses.length
      ? ''
      : callAnalyze.intentMisses.map(im => im.text).join(', '),
    display_wordCustomerSequence: wordCustomerSequence,
    display_wordAgentSequence: wordAgentSequence,
    display_wordAgentGoods: wordAgentGoods,
    display_wordAgentUnPros: wordAgentUnPros,
    display_wordAgentForbids: wordAgentForbids,
    display_wordCustomerGoods: wordCustomerGoods,
    display_wordCustomerBads: wordCustomerBads,
    display_wordSpecial: wordSpecial,
  };
}

export function buildViewCallInfo(callInfo: CampaignQCCallInfo): ViewCampaignQCCallInfo {
  return {
    ...callInfo,
    display_startTime: moment(callInfo.startTime, 'YYYY-MM-DD[T]HH:mm:Ss').format('DD/MM/YYYY HH:mm:ss'),
    display_endTime: moment(callInfo.endTime, 'YYYY-MM-DD[T]HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
    display_duration: convertDurationInSecondIntoDisplayTimeFormat(callInfo.duration, 'full'),
  };
}

export function buildViewCallConversation(
  conversation: CampaignQCCallConversation,
  index: number
): ViewCampaignQCCallConversation {
  const displayConversation: ViewCampaignQCCallConversation = {
    ...conversation,
    display_startTime: convertDurationInSecondIntoDisplayTimeFormat(Math.floor(conversation.startTime), 'simple'),
  };

  return displayConversation;
}

export function buildViewCallHistory(history: CampaignQCCallHistory): ViewCampaignQCCallHistory {
  return {
    ...history,
    display_createdAt: moment(history.createdAt).format('DD/MM/YYYY HH:mm:ss'),
    display_creator: !history.isAuto ? history.creator : '<div class="badge bg-danger">Auto</div>',
    display_scorePercent: `<div class="badge bg-info">${history.scorePercent}</div>`,
    display_categoryName: `<div class="badge bg-info">${history.categoryName}</div>`,
  };
}

export function buildTableColumnsCallHistory() {
  return [
    {
      title: 'Thời gian',
      key: 'display_createdAt',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Người chấm',
      key: 'display_creator',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Điểm tối đa',
      key: 'scriptMaxScoreMain',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Điểm',
      key: 'qcSCore',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Tỷ lệ',
      key: 'display_scorePercent',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Đánh giá',
      key: 'display_categoryName',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/campaign/call-detail/campaign-call-detail.util.ts